import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import get from 'lodash/get'
import * as api from '../../services/api'
import Modal from 'antd/lib/modal'
import Form from 'antd/lib/form'
import Input from 'antd/lib/input'
import message from 'antd/lib/message'
import Typography from 'antd/lib/typography'
import Space from 'antd/lib/space'
import Divider from 'antd/lib/divider'
import Radio from 'antd/lib/radio'
import { CREDIT_CARDS } from '../../constants/credit-cards'

import {
  CardElement,
  useStripe,
  useElements
} from '@stripe/react-stripe-js'
import SecureCheckoutBanner from '../shared/secure-checkout-banner'

export default function PayInvoiceDialog ({
  open,
  onClose,
  user
}) {
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [paymentMethod, setPaymentMethod] = useState(false)
  const [messageApi, contextHolder] = message.useMessage()
  // Initialize an instance of stripe.
  const stripe = useStripe()
  const elements = useElements()
  const payableInvoice = get(user, 'subscriptionData.unpaidInvoice') || user.unpaidOrder

  if (!stripe || !elements || !payableInvoice) {
    // Stripe.js has not loaded yet. Make sure to disable
    // form submission until Stripe.js has loaded.
    return ''
  }

  const errorMessage = (content) => {
    messageApi.destroy()
    messageApi.open({
      type: 'error',
      content: content
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      let paymentMethodId = paymentMethod
      let paymentMethodData = null
      if (!paymentMethod) {
        const { name } = await form.validateFields()
        const { error, paymentMethod } = await stripe
          .createPaymentMethod({
            elements,
            params: {
              billing_details: {
                name: name
              }
            }
          })
        if (error) {
          // show error and collect new card details.
          setLoading(false)
          return errorMessage(error.message)
        }
        paymentMethodData = paymentMethod
        paymentMethodId = paymentMethod.id
      }

      await api.subscription.payInvoice({
        invoiceId: payableInvoice.id,
        paymentMethod: paymentMethodData,
        paymentMethodId: paymentMethodId
      })
      navigate(0)
    } catch (error) {
      setLoading(false)
      errorMessage(error.message)
    }
  }

  const onPaymentMethodSelect = (e) => {
    setPaymentMethod(e.target.value)
  }

  return (
    <>
      {contextHolder}
      <Modal
        title='Pay Invoice'
        open={open}
        okText='Submit'
        confirmLoading={loading}
        okButtonProps={{
          disabled: false
        }}
        cancelButtonProps={{
          disabled: false
        }}
        onOk={handleSubmit}
        onCancel={onClose}
      >
        <Form
          form={form}
          layout='vertical'
          name='subscription'
          initialValues={{
            modifier: 'public'
          }}

        >
          {user.paymentMethods.length
            ? (
              <>
                <Typography.Paragraph>Please select from your available payment methods.</Typography.Paragraph>
                <Radio.Group onChange={onPaymentMethodSelect}>
                  <Space direction='vertical'>
                    {user.paymentMethods.map(pm => {
                      const CardIcon = CREDIT_CARDS[pm.card_brand || 'unknown']
                      return (
                        <Radio key={pm.id} value={pm.payment_method_id}>
                          <div className='cc-options'>
                            <div className='cc-wrapper'>
                              <CardIcon />
                            </div>
                            <span>•••• {pm.card_last4}</span>
                          </div>
                        </Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
                <Divider>Or Create new one</Divider>
              </>
              )
            : null}
          <Form.Item
            label='Full Name' name='name' rules={[{
              required: !user.paymentMethods.length,
              message: 'Name Is Required'
            }]}
          >
            <Input
              placeholder='First and Last Name'
            />
          </Form.Item>
          <CardElement options={{
            hidePostalCode: true,
            classes: {
              base: 'ant-form-item-control-input-content'
            }
          }}
          />
        </Form>
        <SecureCheckoutBanner />
      </Modal>
    </>
  )
}
